module.exports = __webpack_public_path__ + "img/icon3.1384e4c8.png";